export default "__VITE_ASSET__ByD07rZ6__"